<template>
	<div>
        <div class="row">
            <el-card class="pb-0 pt-0" shadow="always" :body-style="{ padding: '0px'}" style="width:100%;">
             
                <div class="row p-0" :style="'background-image: url(' + require('@/assets/img/bg_kinerja_keuangan_intro.png') + ');background-size: 100% 100%;background-repeat: no-repeat;'">
                    <div class="row">
                        <div class="col-md-6">
                           
                        </div>
                        <div class="col-md-6 text-right">
                            <el-button size="mini" @click="toggleFullscreen"><i :class="[toggleIcon ? 'fa-compress' : 'fa-arrows-alt', 'fa']"></i></el-button>
                            <el-button size="mini" @click="$router.push('/performance-report/fuel-retail')"><i class="fa fa-angle-right"></i></el-button>
                        </div>
                    </div>

                    <div style="margin-top:80px;">
                        <h1 style="color:#44546A;font-weight:bold;"><strong>REVIEW KINERJA YTD {{ this.options.months.find(d=> d.value==this.month).name.toUpperCase() }} {{ this.year }}</strong></h1>
                        <h3>PT PERTAMINA RETAIL</h3>
                    </div>
                    <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
                    <br><br><br><br>
                </div>

            </el-card>
    </div>
        
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import {Rainbow, FuelColor, Config,Penanggalan, AxiosWithJar } from '@/utility.js'

export default
{
	extends: KinerjaKeuangan,
	components: { 
		//ReportParamSelect,
        //'editor': Editor,
	},

	data() {
		return {
            //activeName: 'first',
            month: ""+(Penanggalan().bulan-1),
            year: ""+Penanggalan().tahun,
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');
        this.setDefaultPeriod()
    },
    methods: {
        setDefaultPeriod() {
            // Mengecek apakah kunci 'username' sudah ada di localStorage
            if (localStorage.getItem('performanceDefaultMonth') !== null && localStorage.getItem('performanceDefaultYear') !== null) {
                //console.log('Period sudah ada di localStorage');
                let month = localStorage.getItem('performanceDefaultMonth')
                let year = localStorage.getItem('performanceDefaultYear')

                this.month = month
                this.year =  year
            } else {
                //console.log('period belum ada di localStorage');
            }
        },
    },
}
</script>